import styled from 'styled-components';

import { colors, fonts, fontSizes } from 'shared/defaultTheme';

export const CustomSelectWrapper = styled.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
  border: 1px solid ${colors.pattens};
  border-radius: 2px;
  box-shadow: 0 0 4px 0 ${colors.pattens};
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: auto;
  padding: 8px 10px;
  max-height: 375px;
  max-width: 320px;
  min-height: 24px;
  min-width: 127px;
  width: auto;
  &.open {
    flex-direction: column;
    padding-left: 0;
    padding-right: 0;
    position: absolute;
    top: ${({ top }) => top}px;
    left: ${({ left }) => left}px;
    width: ${({ width }) => width}px !important;
    z-index: 3500;
  }
  svg {
    fill: ${colors.black};
    height: 8px;
    width: 13px;
  }
  .default-text {
    color: rgba(0, 0, 0, 0.99);
    font-family: ${fonts.medium};
    font-size: ${fontSizes.xs}px;
    line-height: 15px;
  }
  .item {
    background-color: ${colors.transparent};
    border: none !important;
    color: ${colors.suvaGrey};
    display: flex;
    font-family: ${fonts.medium};
    font-size: ${fontSizes.xs}px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 24px;
    line-height: 15px;
    padding: 0 !important;
    padding-left: 4px !important;
    padding-right: 4px !important;
    width: 100%;
    &:hover {
      background-color: ${colors.whiteSmoke};
    }
    &.selected {
      color: rgba(0, 0, 0, 0.99);
      font-family: ${fonts.medium};
      font-size: ${fontSizes.xs}px;
      line-height: 15px;
      &:hover {
        background-color: ${colors.transparent};
      }
    }
  }
`;
